import { IconProps } from '.';

const PlayIcon = ({ color, customClasses }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      className={customClasses}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4.5C6 3.67157 6.89543 3.21071 7.55279 3.61803L19.5528 10.618C20.2764 11.0607 20.2764 12.0607 19.5528 12.5034L7.55279 19.5034C6.89543 19.9107 6 19.4498 6 18.6214V4.5Z"
        fill={color || '#ebece9'}
      />
    </svg>
  );
};

export default PlayIcon;
